var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReconciled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.148,
    height: 88.179,
    viewBox: "0 0 88.148 88.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16688",
    "data-name": "Group 16688",
    transform: "translate(-1805 -111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "banner-_2_",
    transform: "translate(1788 589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M30.1-477.9c.038.038,19.321,19.321,85.585,85.6l.057-12.281-.057-18.448L60.85-478H42.342C35.57-478,30.061-477.962,30.1-477.9Z",
    transform: "translate(-10.593)",
    fill: "#002bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M17-462.478c0,3.271.191,4.055,1.014,4.247.23.057,1.741.077,3.348.057l2.908-.057-3.635-3.635L17-465.5Z",
    transform: "translate(0 -10.109)",
    fill: "#002bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M427-52.286c0,4.342-.153,4.208,4.457,4.113l2.812-.057-3.635-3.635L427-55.5Z",
    transform: "translate(-331.567 -341.678)",
    fill: "#002bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12745",
    "data-name": "Group 12745",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 589.732, -1347.867)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Reconciled",
    transform: "translate(1915.256 198.856)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reconciled"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciled);
export default __webpack_public_path__ + "static/media/reconciled.1c9803761338779187ec42054b5d63e5.svg";
export { ForwardRef as ReactComponent };